import { render, staticRenderFns } from "./froalawrapper.vue?vue&type=template&id=56955580&"
import script from "./froalawrapper.vue?vue&type=script&lang=js&"
export * from "./froalawrapper.vue?vue&type=script&lang=js&"
import style0 from "./froalawrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports